import PropTypes from 'prop-types'

import RoundIcon from 'components/round_icon'

const providerMap = {
  google: 'google-calendar',
  outlook: 'microsoft-outlook',
  icloud: 'icloud',
  outlook_desktop: 'microsoft-outlook',
  exchange: 'microsoft-exchange'
}

const CalendarProviderIcon = ({ provider, ...restProps }) => (
  <RoundIcon {...restProps} name={providerMap[provider]} />
)

CalendarProviderIcon.propTypes = {
  provider: PropTypes.string.isRequired,
}

export default CalendarProviderIcon
